import {useEffect, useRef, useState} from 'react';
import {Outlet, useLocation} from 'react-router-dom';
import Header from './components/Header';
import headerStyles from './components/Header/Header.module.less';
import styles from './WorkspaceLayout.module.less';
import LoginModal from '@/components/common/LoginModal';
import LogoutConfirmModal from '@/components/common/LogoutConfirmModal';
import {useModalStore} from '@/store/useModalStore';

const WorkspaceLayout: React.FC = () => {
    const location = useLocation();
    const closePointsModal = useModalStore((s) => s.closePointsModal);
    const pageContentRef = useRef<HTMLDivElement>(null);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        closePointsModal();
    }, [closePointsModal, location.pathname]);

    useEffect(() => {
        const el = pageContentRef.current;
        if (!el) return;
        const handleScroll = () => {
            setScrolled(el.scrollTop > 0);
        };
        handleScroll();
        el.addEventListener('scroll', handleScroll, {passive: true});
        // eslint-disable-next-line
        return () => el.removeEventListener('scroll', handleScroll);
    }, []);

    const headerClassName = [headerStyles.overlay, scrolled && headerStyles.scrolled]
        .filter(Boolean)
        .join(' ');

    return (
        <div className={styles.layout}>
            <Header className={headerClassName} />
            <div className={styles.pageContent} ref={pageContentRef}>
                <Outlet />
            </div>
            <LoginModal />
            <LogoutConfirmModal />
        </div>
    );
};

export default WorkspaceLayout;
